import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { catalogUERBaseCostTotalsGql } from '../catalogUerBaseCostQueries';

const requestId = 'catalogUERBaseCostTotals';

interface IUseCatalogUERBaseCostEstimateBasisRows {
    catalogUniqueId?: string;
    uerBaseCostId?: number;
    withEffect?: boolean;
}

export const useCatalogUERBaseCostTotals = (props: IUseCatalogUERBaseCostEstimateBasisRows) => {
    const { catalogUniqueId, uerBaseCostId, withEffect } = props;

    const variables = useMemo(
        () => (catalogUniqueId && uerBaseCostId ? { catalogUniqueId, uerBaseCostId } : undefined),
        [catalogUniqueId, uerBaseCostId],
    );

    const [catalogUERBaseCostTotalsReset] = useResetStoreData({ requestId });

    const [catalogUERBaseCostTotalsData, catalogUERBaseCostTotalsStatus] = useRequest({
        requestId,
        query: catalogUERBaseCostTotalsGql,
        variables,
        withEffect: !!variables && withEffect,
    });

    useEffect(() => {
        catalogUERBaseCostTotalsReset(undefined);
    }, [catalogUERBaseCostTotalsReset]);

    const items = useMemo(
        () => catalogUERBaseCostTotalsData?.catalogUERBaseCostTotals || [],
        [catalogUERBaseCostTotalsData?.catalogUERBaseCostTotals],
    );

    return {
        status: catalogUERBaseCostTotalsStatus,
        items,
    };
};
